import { createFeatureSelector, createSelector } from "@ngrx/store";
import { State as UnitDetailsState } from "../reducers/unit-details";
export const selectUnitDetailsState = createFeatureSelector<UnitDetailsState>('unitDetails');
import { DetailsItem } from '@details/Interfaces/details-item-types';

export const getUnitsDetailsItems = createSelector(
  [selectUnitDetailsState],
  (unitDetailsState: UnitDetailsState) => {
    if (unitDetailsState.unitDetails != undefined) {
      return [
        { name: 'Ref', value: '' + unitDetailsState.unitDetails.Ref } as DetailsItem, { name: 'Name', value: unitDetailsState.unitDetails.Name } as DetailsItem
      ];
    }
    return [];
  }
);

export const getUnitDetails = createSelector(
  [selectUnitDetailsState],
  (unitDetailsState: UnitDetailsState) => {
    return unitDetailsState.unitDetails;
  }
);
